import React from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import LanThanhToanView from "../LanThanhToanView";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import QuanLyChoVayApi from "service/quanLyChoVayApi";
class GiaHanKy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choVay: {},
      dataSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      objGiaHan: {
        choVayId: 0,
        count: 0,
        note: "",
      },
      dataGiaHanSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 2,
        HasTatToanChoDuyet: 0,
      },
      isDeleting: false,
    };
  }
  componentDidMount() {
    let { data, show } = this.props;
    let { choVay, objGiaHan } = this.state;
    if (data && data !== choVay && data.ChoVayId && show) {
      let { dataSearch, dataGiaHanSearch } = this.state;
      dataSearch.choVayId = data.ChoVayId;
      dataGiaHanSearch.choVayId = data.ChoVayId;
      objGiaHan.choVayId = data.ChoVayId;
      this.setState({
        choVay: data,
        dataSearch,
        objGiaHan,
        dataGiaHanSearch,
      });
      this.loadLanDongLai(dataSearch);
      this.loadLichSuGiaHan(dataGiaHanSearch);
      this.kiemTraHopDongChoVayTatToanChoDuyet();
    }
    if (data === choVay && !show) this.setState({ choVay: {} });
  }
  kiemTraHopDongChoVayTatToanChoDuyet() {
    let { data } = this.props;
    let { HasTatToanChoDuyet } = this.state;
    TatToanChoDuyetApi.kiemTraHopDongChoVayTatToanChoDuyet(data.ChoVayId).then(
      (response) => {
        if (response.data.TatToanChoDuyet) {
          HasTatToanChoDuyet = response.data.TatToanChoDuyet;
          this.setState({ HasTatToanChoDuyet });
        }
      }
    );
  }
  loadLanDongLai(dataSearch) {
    let { getLanDongLaiChoVay } = this.props;
    getLanDongLaiChoVay(dataSearch);
  }
  loadLichSuGiaHan(dataSearch) {
    let { getLichSuGiaHanChoVay } = this.props;
    getLichSuGiaHanChoVay(dataSearch);
  }
  onChangeData = (field) => (event) => {
    let { objGiaHan } = this.state;
    objGiaHan[field] = event.target.value;
    this.setState({ objGiaHan });
  };
  handlePageChange = () => (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadLanDongLai(dataSearch);
  };
  handlePageChangeGiaHan = (pageNumber) => {
    let { dataGiaHanSearch } = this.state;
    dataGiaHanSearch.pageIndex = pageNumber;
    this.setState({ dataGiaHanSearch });
    this.loadLichSuGiaHan(dataGiaHanSearch);
  };
  giaHan = () => () => {
    let { dataSearch, objGiaHan } = this.state;
    let { postGiaHanChoVay } = this.props;

    if (!objGiaHan.count) {
      pushNotification("Nhập số lần gia hạn", "warning", "TOP_CENTER", 1000);
      return;
    }
    if (objGiaHan.count <= 0) {
      pushNotification("Số lần gia hạn >0", "warning", "TOP_CENTER", 1000);
      return;
    }
    if (isNaN(objGiaHan.count)) {
      pushNotification(
        "Số lần gia hạn phải là số",
        "warning",
        "TOP_CENTER",
        1000
      );
      return;
    }
    if (objGiaHan.count != parseInt(objGiaHan.count)) {
      pushNotification(
        "Số lần gia hạn phải là số nguyên",
        "warning",
        "TOP_CENTER",
        1000
      );
      return;
    }
    if (!objGiaHan.note) {
      pushNotification("Nhập ghi chú", "warning", "TOP_CENTER", 1000);
      return;
    }

    postGiaHanChoVay(
      {
        ...objGiaHan,
      },
      dataSearch
    );
    objGiaHan.count = 0;
    objGiaHan.note = "";
    this.setState({ objGiaHan });
  };
  renderRow(List) {
    return List.map((item, index) => {
      var lstTP = [];
      if (item.ThuPaid) lstTP = item.ThuPaid.split(",");
      return (
        <tr key={"LanDongLai" + index}>
          <td>{item.IndexId}</td>
          <td className="text-left"> {getDate(item.Time)}</td>
          <td className="text-right">
            {formatNumber(item.ValueGoc + item.ValuePaid)}
          </td>
          <td className="text-right">{formatNumber(item.Paided)}</td>
          <td className="text-right">
            {lstTP.map((itemPaid, idexTP) => {
              var itemPaids = itemPaid.split("#");
              return (
                <p className="text-center">
                  <a href={() => false}>
                    {formatNumber(itemPaids[2]).replace(".00", "")}
                  </a>
                  <span className="date-sm">({getDate(itemPaids[1])})</span>
                </p>
              );
            })}
          </td>
        </tr>
      );
    });
  }
  deleteGD = (item) => () => {
    console.log();
    let chovayid = item.ChoVayID;
    let giaHanId = item.ChovayGiaHanID;
    this.setState({ isDeleting: true });

    QuanLyChoVayApi.deleteGiaHan(chovayid, giaHanId).then((response) => {
      console.log("responseresponse,", response);
      if (response.data.Error == 0) {
        pushNotification("Xóa phiếu thành công", "success", "TOP_CENTER", 2000);
        let { dataGiaHanSearch, dataSearch } = this.state;
        dataGiaHanSearch.pageIndex = 1;
        dataSearch.pageIndex = 1;
        this.setState({ dataGiaHanSearch });
        this.loadLichSuGiaHan(dataGiaHanSearch);
        this.setState({ dataSearch });
        this.loadLanDongLai(dataSearch);
      } else {
        pushNotification(
          "Xóa phiếu không thành công, đã sinh phiếu thu",
          "warning",
          "TOP_CENTER",
          2000
        );
      }
      this.setState({ isDeleting: false });
    });
  };

  renderGiaHanRow(List) {
    let { dataGiaHanSearch } = this.state;
    return List.map((item, index) => {
      return (
        <tr className="">
          <td>{index + 1 + (dataGiaHanSearch.pageIndex - 1) * 2}</td>
          <td className="text-left">{getDate(item.Time)}</td>
          <td className="text-right">{item.SoLan}</td>
          <td className="text-left">{item.Note}</td>
          <td className="text-left">
            {index == 0 && dataGiaHanSearch.pageIndex == 1 && (
              <a href={() => false} onClick={this.deleteGD(item)}>
                <img
                  style={{ marginLeft: "5px" }}
                  src="/app-assets/images/icon-xoa-v2.png"
                />
              </a>
            )}
          </td>
        </tr>
      );
    });
  }
  render() {
    let props = this.props;
    let { data, quanlychovay, buttonLeft } = this.props;
    let {
      List,
      TongCanThanhToan,
      TongPhiKhac,
      TongPhiKho,
      TongThanhToan,
      TongTienGoc,
      TongTienLai,
      totalRow,
      TongPhiKhacHangKy,
    } = quanlychovay.objListDonglai;
    let { ListGiaHan, TotalRowGiaHan } = quanlychovay.LichSuGiaHan;
    let {
      getLanDongLaiChoVayLoading,
      getLichSuGiaHanChoVayLoading,
      postGiaHanChoVayLoading,
    } = quanlychovay;
    let { dataSearch, dataGiaHanSearch, objGiaHan } = this.state;
    let { count, note } = objGiaHan;
    let { Type, StatusPaidHo } = data;
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-table-plus"></i>
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              Gia hạn
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div
            className={
              "loader loader-default " +
              (getLanDongLaiChoVayLoading ||
              getLichSuGiaHanChoVayLoading ||
              postGiaHanChoVayLoading ||
              this.state.isDeleting
                ? "is-active"
                : "")
            }
          ></div>
          <div className="row">
            <div className="col-md-12 col-lg-3  pad-right0">
              <div class="donglai-form">
                <h4>
                  <span style={{ fontWeight: "bold !important;" }}>
                    {" "}
                    <img src="/app-assets/images/icon-gia-han-ky-v2.png" />
                    &nbsp;&nbsp; Gia hạn kỳ thanh toán
                  </span>
                </h4>
                {this.state.HasTatToanChoDuyet === 1 && (
                  <>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="thongbaotattoan">
                          <i
                            class="mdi mdi-alert"
                            style={{ color: "#d39c00" }}
                          ></i>{" "}
                          HỢP ĐỒNG ĐANG CHỜ DUYỆT YÊU CẦU TẤT TOÁN
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane active"
                    id="tab-noidungtra"
                    aria-labelledby="base-tab1"
                  >
                    <div className="detail-tattoan">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Mã cho vay</label>
                            <span className="home-new-blue giahan-block">
                              {data.Code}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label> Số lần gia hạn thêm</label>
                            <input
                              type="text"
                              className="form-control input-sm"
                              value={count}
                              onChange={this.onChangeData("count")}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Lý do gia hạn</label>
                            <textarea
                              rows="3"
                              style={{ minHeight: "80px" }}
                              className="form-control input-sm"
                              placeholder="lý do gia hạn"
                              value={note}
                              onChange={this.onChangeData("note")}
                            ></textarea>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="text-right">
                            {this.state.HasTatToanChoDuyet !== 1 && (
                              <button
                                type="button"
                                className="btn btn-new-main btn-checknew"
                                onClick={this.giaHan()}
                              >
                                <img src="/app-assets/images/icon-true-v2.png" />
                                &nbsp; Xác nhận
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-9">
              <div className="tattoan-formright">
                <ul className="nav nav-tabs bg-tab tab-vaythem">
                  <li className="nav-item active">
                    <a
                      className="nav-link active"
                      id="base-tab12"
                      data-toggle="tab"
                      aria-controls="tab12"
                      href="#tbg-thongtinhd"
                      aria-expanded="true"
                    >
                      <h4>Lịch sử gia hạn</h4>
                    </a>
                  </li>
                  <li className="nav-item active">
                    <a
                      className="nav-link "
                      id="base-tab13"
                      data-toggle="tab"
                      aria-controls="tab13"
                      href="#detailtbg"
                      aria-expanded="true"
                    >
                      <h4>Chi tiết đóng lãi</h4>
                    </a>
                  </li>
                </ul>{" "}
                <div className="tab-content" style={{ marginTop: "10px" }}>
                  <div
                    role="tabpanel"
                    className="tab-pane  active"
                    id="tbg-thongtinhd"
                    aria-labelledby="base-tab1"
                  >
                    <div className="Left808x200 Table-main-morman table-noboder-new">
                      <div className="table-responsive table-new1  table-rounded">
                        <table className="table table-bordered table-hover">
                          <thead>
                            <tr>
                              <th className="w-5">STT</th>
                              <th className="w-15 text-left">Ngày gia hạn</th>
                              <th className="w-20 text-right">
                                Số lần gia hạn thêm
                              </th>
                              <th className="text-left">Lý do gia hạn</th>
                              <th className="text-left">Thao tác</th>
                            </tr>
                          </thead>
                          <tbody>{this.renderGiaHanRow(ListGiaHan)}</tbody>
                        </table>
                      </div>
                    </div>
                    <div className="footer-page-new">
                      <div className="row">
                        <div className="col-xl-12 col-lg-12">
                          <div className="paniation-new d-flex just-end">
                            <nav aria-label="Page navigation">
                              <Pagination
                                activePage={dataGiaHanSearch.pageIndex}
                                itemsCountPerPage={dataGiaHanSearch.pageSize}
                                totalItemsCount={TotalRowGiaHan}
                                pageRangeDisplayed={10}
                                onChange={this.handlePageChangeGiaHan}
                                itemClass="page-item border-none"
                                linkClass="page-link border-none"
                                activeClass="active"
                              />
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="detailtbg"
                    aria-labelledby="base-tab1"
                  >
                    <LanThanhToanView
                      List={List}
                      TongCanThanhToan={TongCanThanhToan}
                      TongPhiKhac={TongPhiKhac}
                      TongPhiKho={TongPhiKho}
                      TongThanhToan={TongThanhToan}
                      TongTienGoc={TongTienGoc}
                      TongTienLai={TongTienLai}
                      totalRow={totalRow}
                      TongPhiKhacHangKy={TongPhiKhacHangKy}
                      handlePageChange={this.handlePageChange()}
                      pageIndex={dataSearch.pageIndex}
                      pageSize={dataSearch.pageSize}
                      Type={Type}
                      StatusPaidHo={StatusPaidHo}
                      HasTatToanChoDuyet={this.state.HasTatToanChoDuyet}
                    ></LanThanhToanView>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div class="from-button-modal">
            <div class="row">
              <div class="col-md-9">{buttonLeft}</div>
              <div class="col-md-3 text-right">
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={props.onHide}
                >
                  <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng&nbsp;
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default GiaHanKy;
